import BundleHeaderSubtitle from '../../pages/BundleItems/BundleHeaderSubtitle'

export type Props = {
  discountHint?: string
}

const BundleHeader = ({ discountHint }: Props) => {
  if (!discountHint) return null

  return (
    <div className="bundle-header" data-testid="bundle-header">
      <div className="container">
        <BundleHeaderSubtitle discountHint={discountHint} />
      </div>
    </div>
  )
}

export default BundleHeader
